<style lang="scss">
    .zicanDownload {
        min-height: 100%;
        height: auto !important;
        .sitebanner {
            background: url(../../assets/images/zican/banner.png) #092b76 no-repeat center;
            height: 187px;
            width: auto;
        }
        .text-info{
            text-align: center;
            margin-top: 200px;
            font-size: 20px;
        }
        .boder{
            border: 1px solid #dddddd;
            height: 40px;
            line-height: 40px;
        }
        .top{
            margin-top: 50px;
        }
        .ata-footer {
            position: fixed;
            bottom: 0;
            border-top: 1px solid #dddddd;
            padding: 7px 20px;
            text-align: center;
            font-size: 12px;
            color: #999999;
            background-color: white;
            width: 100%;
        }
    }
</style>
<template>
    <div class="zicanDownload">
        <div class="sitebanner">
        </div>
        <div class="container text-info">
            <el-row>
                <el-col :span="2"><div class=""></div></el-col>
                <el-col :span="12"><div class="boder">信息修改申请表</div></el-col>
                <el-col :span="8"><div class="boder"><el-button type="text" @click="getTemplate">点击下载</el-button></div></el-col>
                <el-col :span="2"><div class=""></div></el-col>
            </el-row>
            <div class="top">
                <router-link :to="{name:'asset_index'}">
                    <el-button type="primary">返回主页</el-button>
                </router-link>
            </div>
        </div>

        <div class="ata-footer">
            <div>考试服务平台技术专线：<span style="color:rgb(255,0,0);">021-61651876</span> (报名系统操作、缴费查询、准考证打印)</div>
            <div>Copyright ATA 1999-2019.ALL Rights Reserved</div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default{
        data: function () {
            return {}
        },
        created: function () {
        },
        methods: {
            getTemplate: function () {
                // location.href=process.env.VUE_APP_excelPath+ 'excuseTemplate.docx';
                location.href="https://oss-cn-beijing.aliyuncs.com/ata-ers/usp/ueditor%2Fuploadfile%2F2020311%2F142701722585.docx"
            },
        }
    }
</script>